import type {
  LocationSchema,
  WeeklyScheduleSchema
} from '@libs/data-access/entities'
import type { AccountSchema, ShiftRQSchema } from '@libs/data-access/queries'
import moment from 'moment'

import { computeShiftDates } from '../../utils'
import type FormData from '../Models/FormData'

import { getBreaksToSend } from './getBreaksToSend'
import { NO_LABEL_VALUE } from './getLabelFormatted'
import getMealsToSend from './getMealsToSend'

export const UNASSIGNED_SHIFT = -1

type Props = {
  formData: FormData
  shift: ShiftRQSchema
  weeklyscheduleLocation: LocationSchema
  account: AccountSchema
  newWeeklyschedule?: WeeklyScheduleSchema
}

/**
 * Iterates over all user_contracts and days then adapt/format shifts we'll send to the API.
 * We don't want to send any user with potential errors, so we remove them from the submit
 */
const createShiftArrayPayload = ({
  formData,
  shift,
  weeklyscheduleLocation,
  account,
  newWeeklyschedule
}: Props) => {
  const days = !shift?.id
    ? formData.days
    : [{ label: '', value: formData.update_day.value }]

  const labelId =
    formData.label.value === NO_LABEL_VALUE || formData.label.value === ''
      ? ''
      : formData.label.value

  // handling of creation (unassigned === no employee selected, so empty array)
  if (formData.user_contract.length === 0) {
    formData.user_contract.push({ value: null })
  }
  // handling of modification (we can only have one employee)
  if (formData.user_contract[0]?.value === UNASSIGNED_SHIFT) {
    formData.user_contract[0].value = null
  }
  return formData.user_contract
    .map(user => {
      if (user?.highlight === 'danger') {
        return null
      }
      return days.map(day => {
        const date = moment(day.value)
        const { startDate, endDate } = computeShiftDates(
          formData.shift_time_range,
          date
        )
        return {
          id: shift.id,
          weeklyschedule_id: newWeeklyschedule?.id,
          starts_at: startDate.format(),
          account_id: account.id,
          shift_breaks_attributes: getBreaksToSend({
            breaks: formData?.breaks,
            momentStart: startDate,
            shiftBreakList: shift?.shift_breaks
          }),
          shift_meals_attributes: getMealsToSend({
            meals: formData?.meals,
            weeklyscheduleLocation,
            shiftMeals: shift?.shift_meals
          }),
          ends_at: endDate.format(),
          label_id: labelId,
          note: formData.note,
          notify_user: formData.notify_user,
          user_contract_id:
            user.value?.toString() !== UNASSIGNED_SHIFT.toString()
              ? user.value
              : null,
          week: newWeeklyschedule?.week,
          location_id:
            formData.location?.value ||
            (weeklyscheduleLocation && weeklyscheduleLocation.id),
          team_id: newWeeklyschedule?.team_id
        }
      })
    })
    .filter(Boolean)
}

export default createShiftArrayPayload
